import { algoliaCenterSearch } from '../../lib/algoliaCenterSearch'
import {
  generateLocationPlusQuery,
  LocationPlusQueryParams
} from './featuredCentersQuery'

const featuredCentersSearch = ({
  geoloc,
  locationTitle,
  locationAddressParts,
  termAttr,
  termValue,
  searchRadius,
  SUDFocusOnly = false,
  limit
}: LocationPlusQueryParams) =>
  algoliaCenterSearch({
    query: '',
    ...generateLocationPlusQuery({
      geoloc,
      locationTitle,
      locationAddressParts,
      termAttr,
      termValue,
      searchRadius,
      SUDFocusOnly,
      limit
    })
  })

export default featuredCentersSearch
